export default function SellerPage() {
  return (
    <div className="container mt-4">
      <h2>Seller Panel</h2>
      <p>Seller can upload or update food items here.</p>
    </div>
  );
}
